import { NextPage } from 'next'
import { asPage, PageProps } from 'src/components/hoc/asPage'
import { PremiumContributions } from 'src/compositions/PremiumContributions/Index'

const PremiumContributionsPage: NextPage<PageProps<{}, {}>> = () => {
  return <PremiumContributions />
}

export default asPage(PremiumContributionsPage, {
  pageTitle: '案件を探す',
  noindex: false,
})
